import { render, staticRenderFns } from "./TableExpandCustom.vue?vue&type=template&id=7072308a&"
import script from "./TableExpandCustom.vue?vue&type=script&lang=js&"
export * from "./TableExpandCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports